import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center mb-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: _normalizeClass([_ctx.containerClasses, "bg-amber-darken-3"])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          class: _normalizeClass(_ctx.titleClasses)
        }, "Die Zusammenarbeit im Überblick", 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.subtitleClasses)
        }, " In 4 Schritten zum Erfolg ", 2)
      ]),
      _createVNode(_component_v_row, {
        class: _normalizeClass(["mb-6 mx-auto", _ctx.rowClasses]),
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_timeline, {
                density: _ctx.timelineDensity,
                class: "timeline-responsive text-left",
                side: _ctx.timelineSide,
                align: _ctx.timelineAlign
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_timeline_item, {
                    "dot-color": "blue-lighten-2",
                    icon: "mdi-email-outline",
                    size: "large",
                    "fill-dot": ""
                  }, {
                    opposite: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("div", { class: "step-number text-center text-blue-darken-2" }, "1", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", {
                          class: _normalizeClass(["mt-n1 font-weight-light mb-4 text-blue-darken-2", _ctx.stepTitleClasses])
                        }, " Kontakt & Erstgespräch ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.stepContentClasses)
                        }, " Schreibe uns oder buche direkt ein kostenloses Kennenlerngespräch. Wir analysieren gemeinsam deinen aktuellen Außenauftritt und identifizieren ungenutzte Potenziale. ", 2)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_timeline_item, {
                    "dot-color": "green-lighten-2",
                    size: "small",
                    icon: "mdi-chart-bar",
                    "fill-dot": ""
                  }, {
                    opposite: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("div", { class: "step-number text-center text-green-darken-2" }, "2", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", {
                          class: _normalizeClass(["mt-n1 font-weight-light mb-4 text-green-darken-2", _ctx.stepTitleClasses])
                        }, " Strategie & Konzept ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.stepContentClasses)
                        }, " Wir entwickeln eine individuelle Content-Strategie zugeschnitten auf deine Marke, Zielgruppe und Unternehmensziele. ", 2)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_timeline_item, {
                    "dot-color": "orange-lighten-2",
                    size: "x-large",
                    icon: "mdi-camera-outline",
                    "fill-dot": ""
                  }, {
                    opposite: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("div", { class: "step-number text-center text-orange-darken-2" }, "3", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", {
                          class: _normalizeClass(["mt-n1 font-weight-light mb-4 text-orange-darken-2", _ctx.stepTitleClasses])
                        }, " Umsetzung & Content-Produktion ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.stepContentClasses)
                        }, " Wir übernehmen Planung, Koordination und Umsetzung von Inhalten. ", 2)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_timeline_item, {
                    "dot-color": "purple-lighten-2",
                    size: "small",
                    icon: "mdi-chart-line",
                    "fill-dot": ""
                  }, {
                    opposite: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("div", { class: "step-number text-center text-purple-darken-2" }, "4", -1)
                    ]))]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h2", {
                          class: _normalizeClass(["mt-n1 font-weight-light mb-4 text-purple-darken-2", _ctx.stepTitleClasses])
                        }, " Auswertung & Optimierung ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.stepContentClasses)
                        }, " Du bekommst alle Inhalte fertig und danach optimieren wir weiter. ", 2)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["density", "side", "align"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 8, ["class"]))
}